import { graphql } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';

const mutation = graphql`
    mutation subscribeUserMutation($input: EditNewslettersInput!) {
        editNewsletters(input: $input) {
            clientMutationId
        }
    }
`;

export function subscribeUserMutation(environment, userServiceId) {
    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                userServiceId,
                promotional: 'Y',
            },
        },
    });
}
